import { useUser } from "@/lib/user-context";
import { Eye, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const SPECIALTY_LABELS: Record<string, string> = {
  art_department: "Art Department",
  screen_burner: "Screen Burner",
  ink_mixer: "Ink Mixer",
  press_operator: "Press Operator",
  embroidery_operator: "Embroidery Operator",
  digitizer: "Digitizer",
  heat_press_operator: "Heatpress Operator",
  product_handler: "Product Handler",
  quality_control: "Quality Control",
  polybag_operator: "Polybag Operator",
  order_management: "Order Management",
  account_manager: "Account Manager",
};

function formatSpecialty(s: string): string {
  return SPECIALTY_LABELS[s] || s.replace(/_/g, " ");
}

export function ImpersonationBanner() {
  const { isImpersonating, displayName, specialties, stopImpersonating, originalDisplayName } = useUser();

  if (!isImpersonating) return null;

  return (
    <div
      className="w-full px-4 py-2 flex items-center justify-between gap-3 text-sm z-50"
      style={{ backgroundColor: "#dc2626", color: "#ffffff" }}
    >
      <div className="flex items-center gap-2 min-w-0">
        <Eye className="h-4 w-4 shrink-0" />
        <div className="truncate">
          <span className="font-semibold">{displayName}</span>
          {specialties.length > 0 && (
            <span className="font-normal opacity-80 ml-2 text-xs">
              {specialties.map(formatSpecialty).join(" \u00b7 ")}
            </span>
          )}
        </div>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="text-xs gap-1 shrink-0"
        style={{
          borderColor: "#ffffff",
          color: "#ffffff",
          backgroundColor: "transparent",
        }}
        onClick={stopImpersonating}
      >
        <ArrowLeft className="h-3 w-3" />
        Back to {originalDisplayName || "my account"}
      </Button>
    </div>
  );
}
